export default __webpack_public_path__ + "static/media/digbicks.3e2fefc3.svg";